<template>
  <div class="the-section">
    <div class="toolbar clearfix" style="margin-bottom: 20px;">
      <a-button type="default" @click="gotoBack">返回</a-button>
      <a-button
        style="margin-left: 20px;"
        type="primary"
        @click="openSectionModal"
        >增加章</a-button
      >
    </div>

    <div>
      <a-empty v-if="!section || section.length === 0" />
      <a-collapse
        v-else
        v-model="activeKey"
        :expand-icon-position="expandIconPosition"
      >
        <a-collapse-panel v-for="item in section" :key="String(item.id)">
          <div slot="header" class="header-panel clearfix">
            <div class="header-panel--section">
              <div class="meta-item">
                <a-avatar
                  style="margin-right: 6px;"
                  shape="square"
                  :size="75"
                  :src="item.icon"
                  >无封面</a-avatar
                >
              </div>
              <div class="meta-item detail">
                <div class="item-item--title">
                  <h4 class="item-text">
                    <strong>第{{ item.num }}章{{ item.name }}</strong>
                  </h4>
                </div>
                <div class="item-item--desc">
                  <p class="item-text">
                    <label for="">描述：</label>
                    <span>
                      {{ item.description }}
                    </span>
                  </p>
                </div>
                <div class="item-item--footer">
                  <div class="footer-item">
                    <a-icon type="calendar" style="margin-right: 5px;" />
                    <span>{{ formatTime(item.createdAt) }}</span>
                  </div>
                  <div class="footer-item">
                    <a-icon type="clock-circle" style="margin-right: 5px;" />
                    <span>{{
                      getDurationOfLessons(item.lessons) | duration
                    }}</span>
                  </div>
                  <div class="footer-item">
                    <a
                      href="javascript:;"
                      @click="e => openLessonModal(e, item.id)"
                      ><a-icon type="plus" style="margin-right: 5px;" /><span
                        >增加小节</span
                      ></a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="header-panel--extra">
              <a-popconfirm
                title="确定删除吗 ?"
                @confirm="e => handleRemove(e, item.id)"
              >
                <a-button type="default" @click="e => e.stopPropagation()"
                  >删除 <a-icon type="delete"></a-icon
                ></a-button>
              </a-popconfirm>
              <a-button
                style="margin-left: 10px;"
                type="default"
                @click="e => openEditSectionModal(e, item.id)"
                >修改</a-button
              >
            </div>
          </div>
          <a-list item-layout="horizontal" :data-source="item.lessons">
            <a-list-item slot="renderItem" slot-scope="item">
              <a slot="actions" @click="openEditLessonModal(item.id)"
                >修改 <a-icon type="edit"></a-icon
              ></a>
              <template slot="actions">
                <a-popconfirm
                  title="确定删除吗 ?"
                  @confirm="onDelLesson(item.id)"
                >
                  <a href="javascript:;"
                    >删除 <a-icon type="delete"></a-icon
                  ></a>
                </a-popconfirm>
              </template>
              <div class="list-item clearfix">
                <div class="list-item-cell lesson-num">
                  <strong>第{{ item.num }}节</strong>
                </div>

                <div class="list-item-cell">
                  <p>
                    <label for="">名称：</label>
                    <span>{{ item.name }}</span>
                  </p>
                  <p>
                    <label for="">描述：</label>
                    <span>{{ item.description }}</span>
                  </p>
                  <p>
                    <label for="">讲师：</label>
                    <span>{{ item.teacher | alt }}</span>
                  </p>
                </div>

                <div class="list-item-cell video-panel">
                  <div
                    class="upload-panel clearfix"
                    v-if="uploadMap[item.id] === true"
                  >
                    <VideoUpload
                      @uploaded="res => uploaded(res, item.id)"
                      @cancel="() => onClickUploadCancel(item.id)"
                      :max="700"
                    />
                  </div>
                  <div v-else>
                    <p class="video-text">
                      <!-- <label for="">视频：</label> -->
                      <span>
                        <a
                          v-if="item.videos.length > 0"
                          :href="item.videos[0] && item.videos[0].url"
                          target="_blank"
                          >{{ item.videos[0] && item.videos[0].name }}</a
                        >
                        <span v-else>暂无视频</span>
                      </span>
                    </p>
                    <div class="video-desc">
                      <ul class="video-actions clearfix actions-left">
                        <li class="video-actions-item">
                          <span>
                            <label for="">时长：</label>
                            <span>{{
                              item.videos[0] &&
                                item.videos[0].duration | duration
                            }}</span>
                          </span>
                        </li>
                        <li class="video-actions-item">
                          <span @click="onClickUpload(item.id)">
                            <a-icon type="upload"></a-icon>
                          </span>
                        </li>
                      </ul>
                      <!-- <ul class="video-actions clearfix actions-right">
                        <li class="video-actions-item">
                          <span @click="onClickUpload(item.id)">
                            <a-icon type="upload"></a-icon>
                          </span>
                        </li>
                        <li
                          v-if="item.videos.length > 0"
                          class="video-actions-item"
                        >
                          <a-popconfirm
                            title="确定要删除吗 ?"
                            @confirm="() => onDeleteVideo(item.id)"
                          >
                            <span>
                              <a-icon type="delete"></a-icon>
                            </span>
                          </a-popconfirm>
                        </li>
                      </ul> -->
                    </div>
                  </div>
                </div>
              </div>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
    </div>
    <SectionForm v-model="visible" :mode="sMode" :afterSubmit="afterSubmit" />
    <LessonForm
      v-model="lessonFormVisible"
      :mode="lMode"
      :afterSubmit="afterLessonSubmit"
    />
  </div>
</template>

<script>
import SectionForm from './SectionForm'
import LessonForm from './LessonForm'
import {
  removeSection,
  getAllSection,
  removeLesson,
  updateLesson
} from '@/api/course/course'
import moment from 'moment'
import VideoUpload from '@/components/Upload/VideoUpload'

export default {
  components: { SectionForm, LessonForm, VideoUpload },
  data() {
    return {
      activeKey: ['1'],
      expandIconPosition: 'left',
      list: [],
      editingRow: null,
      section: [],
      visible: false,
      afterSubmit: () => {
        this.fetchData()
      },
      lessonFormVisible: false,
      afterLessonSubmit: () => {
        this.fetchData()
      },
      sMode: {
        type: 'add'
      },
      lMode: {
        type: 'add'
      },
      uploadMap: {}
    }
  },
  watch: {
    // activeKey(key) {
    //   console.log(key)
    // },
    $route() {
      this.fetchData()
    }
  },
  computed: {
    courseId() {
      return this.$route.query.courseId
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      let id = this.$route.query.courseId
      if (id) {
        getAllSection({ id: id }).then(res => {
          if (res.code === 200) {
            this.section = res.result
          }
        })
      }
    },
    gotoBack() {
      this.$router.push({
        name: 'course'
      })
    },
    openLessonModal(e, id) {
      e.stopPropagation()
      this.lessonFormVisible = true
      this.lMode = {
        type: 'add',
        sectionId: id
      }
    },
    openEditLessonModal(id) {
      this.lessonFormVisible = true
      this.lMode = {
        type: 'update',
        id: id
      }
    },

    openSectionModal() {
      this.visible = true
      this.sMode = {
        type: 'add'
      }
    },
    openEditSectionModal(e, id) {
      e.stopPropagation()
      this.visible = true
      this.sMode = {
        type: 'update',
        id
      }
    },
    handleRemove(e, id) {
      e.stopPropagation()
      removeSection({ courseId: this.courseId, sectionId: id }).then(() => {
        this.$notification['success']({
          message: '成功',
          description: '删除成功',
          duration: 3
        })
        this.fetchData()
      })
    },
    formatTime(text) {
      return moment(text).format('YYYY-MM-DD HH:mm:ss')
    },

    onDelLesson(id) {
      removeLesson(id).then(res => {
        if (res.code === 200) {
          this.$notification['success']({
            message: '成功',
            description: '删除成功'
          })
          this.fetchData()
        }
      })
    },
    uploaded(res, id) {
      const data = res || {}
      updateLesson(id, {
        videos: [
          {
            name: data.name,
            fileId: data.id,
            url: data.url,
            duration: data.duration
          }
        ]
      }).then(resp => {
        if (resp.code === 200) {
          this.$notification['success']({
            message: '成功',
            description: '上传成功'
          })
          this.fetchData()
          setTimeout(() => {
            const map = this.uploadMap || {}
            map[id] = false
            this.uploadMap = JSON.parse(JSON.stringify(map))
          }, 1500)
        }
      })
    },
    onClickUpload(id) {
      const map = this.uploadMap || {}
      map[id] = true
      this.uploadMap = JSON.parse(JSON.stringify(map))
    },
    onClickUploadCancel(id) {
      const map = this.uploadMap || {}
      map[id] = false
      this.uploadMap = JSON.parse(JSON.stringify(map))
    },
    onDeleteVideo(id) {
      updateLesson(id, {
        videos: []
      }).then(resp => {
        if (resp.code === 200) {
          this.$notification['success']({
            message: '成功',
            description: '删除成功'
          })
          this.fetchData()
        }
      })
    },
    getDurationOfLessons(lessons = []) {
      return lessons.reduce((count, item) => {
        let v = item.videos[0] || {}
        let duration = v.duration || 0
        return duration + count
      }, 0)
    }
  }
}
</script>

<style scoped lang="less">
.header-panel--section {
  float: left;
  display: flex;
  .item-text {
    margin: 0;
    margin-bottom: 5px;
  }
  .meta-item {
    margin-right: 25px;
  }
  .item-item--footer {
    display: flex;
    .footer-item {
      margin-right: 30px;
    }
  }
}
.header-panel--extra {
  float: right;
}
.list-item {
  padding-left: 25px;
  width: 100%;
  .list-item-cell {
    float: left;
    margin-right: 50px;
  }
  .lesson-num {
    width: 54px;
    padding-top: 33px;
  }
  .video-panel {
    width: 547px;
    float: right;
    padding-top: 18px;
    padding-bottom: 35px;
    border-left: 1px solid #ddd;
    padding-left: 50px;
  }
}
// 视频上传工具
// .video-panel {
//   width: 350px;
// }
.upload-panel {
  padding-right: 20px;
  .upload-panel-cancel {
    float: right;
  }
}
.video-text {
  margin-bottom: 5px;
}
.actions-left {
  float: left;
}
.actions-right {
  float: right;
}
.video-actions {
  list-style: none;
  margin: 0;
  padding: 0;
  // padding-top: 18px;
  .video-actions-item {
    list-style: none;
    float: left;
    padding: 0 16px;
    border-right: 1px solid #b9b9b9;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      border-right: none;
    }
    &:hover {
      color: red;
    }
  }
}
</style>
